var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function scrollToElement(ref) {
  var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  if (!ref || !ref.current) {
    window.scrollTo(0, 0);
    return;
  }
  var elementBoundingRect = ref.current.getBoundingClientRect();
  window.scrollTo(0, elementBoundingRect.top + window.pageYOffset - offset);
}
__name(scrollToElement, "scrollToElement");
export {
  scrollToElement
};
